import { execSyntax, getContext, } from "@icg360/pi-syntax-tools";
import { KeyExecutionError } from "../errors";
export function createKeyMaps(model) {
    var _a, _b, _c, _d, _e, _f;
    const keyToNode = {};
    const nodeToKey = {
        terms: {},
        iterables: {},
    };
    const keyConflicts = [];
    for (const term of Object.values(model.terms)) {
        let keyFn = null;
        if (((_a = term.key) === null || _a === void 0 ? void 0 : _a.type) === "syntax-tree") {
            keyFn = term.key.tree;
        }
        else if (((_b = model.key) === null || _b === void 0 ? void 0 : _b.type) === "syntax-tree") {
            keyFn = model.key.tree;
        }
        const key = keyFn
            ? String(tryExecSyntax(keyFn, getContext({
                meta: model.meta,
                terms: model.terms,
                iterables: model.iterables,
                this: {
                    term,
                },
            }), ((_c = term.key) === null || _c === void 0 ? void 0 : _c.type) === "syntax-tree" ? term.name : undefined))
            : term.name;
        if (keyToNode[key]) {
            keyConflicts.push({
                node: {
                    type: "term",
                    termName: term.name,
                },
                keys: [key],
            });
        }
        keyToNode[key] = {
            type: "term",
            termName: term.name,
        };
        nodeToKey.terms[term.name] = key;
    }
    for (const iterable of Object.values(model.iterables)) {
        const max = Number(iterable.max);
        if (isNaN(max)) {
            throw new Error(`Invalid max for iterable ${iterable.name}`);
        }
        if (!nodeToKey.iterables[iterable.name]) {
            nodeToKey.iterables[iterable.name] = [];
        }
        const conflicts = {};
        for (let index = 0; index < max; index += 1) {
            const instance = {};
            for (const iterableTerm of Object.values(iterable.terms)) {
                const iterableContext = getContext({
                    meta: model.meta,
                    terms: model.terms,
                    iterables: model.iterables,
                    this: {
                        index,
                        position: index + 1,
                        iterable,
                        term: iterableTerm,
                    },
                });
                let keyFn = null;
                if (((_d = iterableTerm.key) === null || _d === void 0 ? void 0 : _d.type) === "syntax-tree") {
                    keyFn = iterableTerm.key.tree;
                }
                else if (((_e = iterable.key) === null || _e === void 0 ? void 0 : _e.type) === "syntax-tree") {
                    keyFn = iterable.key.tree;
                }
                const key = keyFn
                    ? String(tryExecSyntax(keyFn, iterableContext, ((_f = iterableTerm.key) === null || _f === void 0 ? void 0 : _f.type) === "syntax-tree"
                        ? iterableTerm.name
                        : undefined, iterable.name))
                    : iterableTerm.name + (index + 1);
                if (keyToNode[key]) {
                    if (conflicts[iterableTerm.name]) {
                        conflicts[iterableTerm.name].push(key);
                    }
                    else {
                        conflicts[iterableTerm.name] = [key];
                    }
                }
                keyToNode[key] = {
                    type: "iterable-term",
                    iterableName: iterable.name,
                    termName: iterableTerm.name,
                    iterableIndex: index,
                };
                instance[iterableTerm.name] = key;
            }
            nodeToKey.iterables[iterable.name].push(instance);
        }
        for (const [termName, keys] of Object.entries(conflicts)) {
            keyConflicts.push({
                node: {
                    type: "iterable-term",
                    iterableName: iterable.name,
                    termName,
                },
                keys,
            });
        }
    }
    return { keyToNode, nodeToKey, keyConflicts };
}
function tryExecSyntax(syntax, context, termName, iterableName) {
    try {
        return String(execSyntax(syntax, context));
    }
    catch (ex) {
        if (ex instanceof Error) {
            throw new KeyExecutionError(ex.message, syntax, termName, iterableName);
        }
        throw ex;
    }
}
//# sourceMappingURL=map-keys.js.map